import React, { useEffect } from 'react';

import * as S from './Modal.styles';

const ModalContainer = ({
  closeModal,
  children,
}) => {
    const winSize = window.screen.width;

    useEffect(() => {
        document.querySelector('body').classList.add('noScroll');
        return () => {
        document.querySelector('body').classList.remove('noScroll');
        }
    }, []);
    return (
        <React.Fragment>
            { winSize > 767 && (<S.ModalContainer>{children}</S.ModalContainer>) || (<S.MobileModalContainerv>{children}</S.MobileModalContainerv>) }
            <S.ModalBackdrop onClick={closeModal} />
        </React.Fragment>
    )
}

export default ModalContainer;
